export default __webpack_public_path__ + "static/media/DTproto1.ea067353.jpg";